import { useCallback, useReducer } from 'react';

enum ControlCommands {
  Reset = 'reset',
}

export const useMergeState = <T>(defaultValue: T) => {
  const [state, mergeState] = useReducer(
    (oldState: T, patch: Partial<T> | ControlCommands) => {
      if (patch === ControlCommands.Reset) {
        return defaultValue;
      }

      const nextState = { ...oldState };
      for (const k in patch) {
        nextState[k] = patch[k] as T[Extract<keyof T, string>];
      }

      return nextState;
    },
    defaultValue,
  );

  const reset = useCallback(() => mergeState(ControlCommands.Reset), []);

  return {
    state,
    mergeState,
    reset,
  };
};
